/** Formats a stored Eastern wall-clock value for display without changing its value. */
export const formatScheduleTime = (time: string): string => {
  const match = /^(\d{2}):(\d{2})$/u.exec(time);
  if (!match) return time;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23 || minute > 59) return time;
  const meridiem = hour < 12 ? "AM" : "PM";
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${String(minute).padStart(2, "0")} ${meridiem}`;
};
